export { default } from '@/views/Jobs';

// DO NOT REMOVE — load-bearing. Forces SSR so Next emits plain <script> tags
// (no `crossorigin`); our cross-origin CDN sends no Access-Control-Allow-Origin,
// so a statically-exported page CORS-blocks all chunks and renders blank.
// Safe to remove only once the CDN serves CORS headers for _next/static/*.
export const getServerSideProps = () => Promise.resolve({ props: {} });
